var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84017 19.5238L12.2568 24.6231C12.4579 24.8126 12.7237 24.9182 13 24.9182C13.2763 24.9182 13.5421 24.8126 13.7432 24.6231L19.1598 19.5238C19.3019 19.3898 19.4051 19.2199 19.4585 19.032C19.5118 18.8442 19.5135 18.6454 19.4632 18.4567L16.3486 6.72965L19.2833 2.81665C19.404 2.6557 19.4776 2.46431 19.4956 2.26394C19.5137 2.06356 19.4756 1.86211 19.3856 1.68216C19.2957 1.50222 19.1574 1.35088 18.9862 1.24511C18.8151 1.13934 18.6179 1.08331 18.4167 1.08331H7.58333C7.38215 1.08331 7.18493 1.13934 7.01379 1.24511C6.84265 1.35088 6.70434 1.50222 6.61437 1.68216C6.5244 1.86211 6.48631 2.06356 6.50438 2.26394C6.52245 2.46431 6.59595 2.6557 6.71667 2.81665L9.65142 6.72965L6.53683 18.4567C6.48652 18.6454 6.48815 18.8442 6.54155 19.032C6.59495 19.2199 6.69812 19.3898 6.84017 19.5238ZM16.25 3.24998L14.625 5.41665H11.375L9.75 3.24998H16.25ZM11.6664 7.58331H14.3336L17.2033 18.3896L13 22.3459L8.79667 18.3896L11.6664 7.58331Z",
    fill: "#034A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTie);
export default __webpack_public_path__ + "static/media/tie.3b645bd2ebc65ca9838091e06b57391b.svg";
export { ForwardRef as ReactComponent };